import { render, staticRenderFns } from "./ResourceListSearch.vue?vue&type=template&id=cb35b75c&scoped=true&"
import script from "./ResourceListSearch.vue?vue&type=script&lang=js&"
export * from "./ResourceListSearch.vue?vue&type=script&lang=js&"
import style0 from "./ResourceListSearch.vue?vue&type=style&index=0&id=cb35b75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb35b75c",
  null
  
)

export default component.exports